import { SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import {
  IAttendeeStatusRequest,
  AttendeeInfo,
  IAttendeeInfoCompact,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  IAttendeeInfo,
} from "./entity/AttendeeEntity";
import { IAttendeeService } from "./IAttendeeService";
import {
  IAuthenticationService,
  TokenIAuthenticationService,
} from "@/authentication";
import { baContainer } from "@/ioc";
import axios, { AxiosResponse } from "axios";
import { MeetingDetails } from "../resource-service/entity/MeeingEntity";
import { generateCId } from "@/components/ui/TimeLine/constains/FunctionTimeline";
import { cloneDeep } from "lodash";
import {
  FORMAT_DATE_DEFAULT,
  TimeFunction,
} from "@/common/datetime/TimeFunction";

const URL_GRAPh = "https://graph.microsoft.com";

export class AttendeeService implements IAttendeeService {
  private accessToken?: string;

  getScheduleAttendee = async (
    request: IAttendeeStatusRequest,
    mapAttendee: Record<string, IAttendeeInfoCompact>,
    isNextDate?: boolean
  ): Promise<SearchResponse<AttendeeInfo>> => {
    if (!this.accessToken) {
      const authenticationService: IAuthenticationService = baContainer.resolve(
        TokenIAuthenticationService
      );
      const accessToken = await authenticationService.GetCallbackToken();
      //const accessToken = "eyJ0eXAiOiJKV1QiLCJub25jZSI6IkRPZVRRQ0xrMmJKbm10QkxGNXoxTjNTVE9QTFlFVnpfUmJTYzhmeURSSjAiLCJhbGciOiJSUzI1NiIsIng1dCI6Ik1HTHFqOThWTkxvWGFGZnBKQ0JwZ0I0SmFLcyIsImtpZCI6Ik1HTHFqOThWTkxvWGFGZnBKQ0JwZ0I0SmFLcyJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8xODFiZTcwMS04NzQwLTRmYmQtYjkwZi1mZWQ1NjIyNWI3YzgvIiwiaWF0IjoxNzIyOTExMTM2LCJuYmYiOjE3MjI5MTExMzYsImV4cCI6MTcyMjk5NzgzNiwiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFUUUF5LzhYQUFBQWFjN3RzM3ZqK2xRcklwQ0hGRmRYeGpEME82TFhtSmZzVzNDWThDRG1KOTV5M0hEaE1NdjZ2dlF1RmdDRmVBTi8iLCJhbXIiOlsicHdkIl0sImFwcF9kaXNwbGF5bmFtZSI6Im9mZmljZS1hZGQtaW4tc3NvIiwiYXBwaWQiOiIzMmVhN2I5Yy1kZGI0LTQ4OWQtYmQyNC0yODY0MDM5OTJlODYiLCJhcHBpZGFjciI6IjAiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIxMTMuMTkwLjI0Mi4xNTUiLCJuYW1lIjoiUFZEIiwib2lkIjoiYWNkYzVmOTktYzI0Ni00YjcwLWFmNjctMzBhY2NiNGUxZjE4IiwicGxhdGYiOiIzIiwicHVpZCI6IjEwMDMyMDAzOUVFRDI0MjEiLCJyaCI6IjAuQVhFQUFlY2JHRUNIdlUtNURfN1ZZaVczeUFNQUFBQUFBQUFBd0FBQUFBQUFBQURBQUlzLiIsInNjcCI6IkNhbGVuZGFycy5SZWFkLlNoYXJlZCBEaXJlY3RvcnkuUmVhZC5BbGwgZW1haWwgb3BlbmlkIHByb2ZpbGUgVXNlci5SZWFkIiwic3ViIjoiQkFOQlBQVUpBZmpDem5HNEk0NklkSEdhNHhSMXJuZzVMZll2M3pyUTdvZyIsInRlbmFudF9yZWdpb25fc2NvcGUiOiJBUyIsInRpZCI6IjE4MWJlNzAxLTg3NDAtNGZiZC1iOTBmLWZlZDU2MjI1YjdjOCIsInVuaXF1ZV9uYW1lIjoicHZkQGFvcGJhLm9ubWljcm9zb2Z0LmNvbSIsInVwbiI6InB2ZEBhb3BiYS5vbm1pY3Jvc29mdC5jb20iLCJ1dGkiOiJBOFZYRG50WTVrQy1JMU55NE1iOUFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX2NjIjpbIkNQMSJdLCJ4bXNfaWRyZWwiOiIxIDQiLCJ4bXNfc3NtIjoiMSIsInhtc19zdCI6eyJzdWIiOiJQTzdwS0w0MVNVY1V3a3htRlRvV2JiRURHQXVYcEYxN2k5VHF4Ym4wcjZvIn0sInhtc190Y2R0IjoxNjM5MDc2MTIwfQ.GWw94pdJyH2SqOWHgGPa94EvZrSFgMaE3CSLRjy9ea6GXKV3VkbzaL8pUgxcrxtzUYuFlzKsQHnnY8FZldJ9wcGV2dKZ2kGSavYOUYaiul8BjG_Kn7WOZSS0ZWF275RLHhBcNr5LzzwUyaK3PJhbXRGYsHrtgo_umEnFxhw_sUrbxH44LBMYoyUIJn8utPoaVC0O3VLiuhXG_sNzzYwwwC9LhuOEzBsg6hjYpXWRWKQdJ5bBrvUXWcyeWaGYU7Dfgy48Sq9Z8Np3OhwhrErAgTwC010nqxyd8nXi24vE6SGyO7YgvXu-yHfeYzUmzMSyyAknBylASHjTSzrdlaNE3A";
      this.accessToken = accessToken;
    }
    const url: string = `${URL_GRAPh}/v1.0/me/calendar/getSchedule`;
    const requestClone = cloneDeep(request);
    const startDate: Date = requestClone.startTime.dateTime
      ? new Date(requestClone.startTime.dateTime)
      : new Date();
    const endDate: Date = requestClone.endTime.dateTime
      ? new Date(requestClone.endTime.dateTime)
      : new Date();
    if (!isNextDate) {
      startDate.setDate(startDate.getDate() - 1);
      endDate.setDate(endDate.getDate() + 1);
    }

    requestClone.startTime.dateTime = TimeFunction.dateTimeFormatter(
      startDate,
      `${FORMAT_DATE_DEFAULT}T00:00:00`
    ) as string;
    requestClone.endTime.dateTime = TimeFunction.dateTimeFormatter(
      endDate,
      `${FORMAT_DATE_DEFAULT}T23:59:59`
    ) as string;
    return axios
      .post(url, requestClone, {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
      .then((res) => {
        if (res.data?.value) {
          res.data.value = (res.data.value || []).map((item: any) => {
            return {
              ...item,
              dateTime: {
                start: request.startTime.dateTime,
                end: request.endTime.dateTime,
              },
            };
          });
        }
        const resp = new SearchResponse<AttendeeInfo>(res, AttendeeInfo);
        resp.data = resp.data.map((item) => {
          item.name = mapAttendee[item.email]?.name;
          item.displayName = mapAttendee[item.email]?.name;
          item.isOrganizer = mapAttendee[item.email]?.isOrganizer;
          return item;
        });
        return resp;
      })
      .catch((err) => {
        return new SearchResponse<AttendeeInfo>(err?.response);
      });
  };

  fetchMeetingDaysByMonth = (
    request: IAttendeeStatusRequest
  ): Promise<SearchResponse<string>> => {
    const url: string = `${URL_GRAPh}/v1.0/me/calendar/getSchedule`;
    return axios
      .post(url, request, {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
      .then((res: AxiosResponse) => {
        const resp = new SearchResponse<AttendeeInfo>(res, AttendeeInfo);
        const respCustom = new SearchResponse<string>(res);
        respCustom.data = (
          resp.data[0] && resp.data[0]?.event ? resp.data[0].event : []
        ).map((item) => {
          return item.start?.toISOString();
        });
        return respCustom;
      })
      .catch((err) => {
        return new SearchResponse<string>(err?.response);
      });
  };

  fetchMeetingByDate = (
    request: IAttendeeStatusRequest,
    mapAttendee: Record<string, IAttendeeInfoCompact>
  ): Promise<SearchResponse<MeetingDetails>> => {
    const url: string = `${URL_GRAPh}/v1.0/me/calendar/getSchedule`;
    return axios
      .post(url, request, {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
      .then((res) => {
        const resp = new SearchResponse<AttendeeInfo>(res, AttendeeInfo);
        const respCustom = new SearchResponse<MeetingDetails>(res);
        respCustom.data = (
          resp.data[0] && resp.data[0]?.event ? resp.data[0].event : []
        ).map((item) => {
          return new MeetingDetails({
            startTime: {
              dateTime: item.start?.toISOString(),
              timeZone: item.timeZone || "",
            },
            endTime: {
              dateTime: item.end?.toISOString(),
              timeZone: item.timeZone || "",
            },
            subject: item.subject,
            organizer: {
              emailAddress: {
                displayName: mapAttendee[resp.data[0].email]?.name,
                address: resp.data[0].email,
              },
            },
            guid: generateCId(),
            status: item.status,
            timelineStatus: item.timelineStatus,
          });
        });
        respCustom.data.sort((a, b) => {
          const aTime = new Date(a.startTime?.dateTime || "");
          const bTime = new Date(b.startTime?.dateTime || "");
          if (aTime.getTime() > bTime.getTime()) {
            return 1;
          } else if (aTime.getTime() < bTime.getTime()) {
            return -1;
          } else {
            return 0;
          }
        });
        return respCustom;
      })
      .catch((err) => {
        return new SearchResponse<MeetingDetails>(err?.response);
      });
  };
}
